import { SemanticUI } from '@iterable/deprecated_react_components';
import { widgetTypeOptions } from '../dashboardWidget/widgets';
import * as widgetTypes from '../../utils/dashboardWidgetTypes';
import { NULL_METRIC } from '../../utils/dashboardWidgetUtils';
import { getWidgetSettingsForVisualization } from '../../utils/visualizations';

// type Props = {
//   /** Callback function when widgetType changes. */
//   onChange: ({}, { value: string }) => void,
//   /** Placeholder test to show in dropdown. */
//   placeholder: string,
//   /** Currently selected widgetType. */
//   widgetType: string,
// };

const defaultProps = {
  onChange: () => {},
  placeholder: 'Select widget type',
  widgetType: widgetTypes.METRIC,
};

const WidgetTypeDropdown = (props) => {
  const { onChange, placeholder, widgetType } = props;

  /**
   * handleChange
   * Callback function when metric changes.
   * @param { Object } e: The change event.
   * @param { Object } dropdownProps: The props of the dropdown containing the new widgetType.
   * @return { void }
   */
  const handleChange = (e, { value }) => {
    if (value === widgetTypes.METRIC) {
      onChange(e, { settings: { metric: null, visualization: '' }, type: value });
    } else {
      const visualization = value;
      const { settings, ...config } = getWidgetSettingsForVisualization(visualization, true);
      onChange(e, {
        ...config,
        settings: { ...settings, metric: NULL_METRIC, visualization },
        type: value,
      });
    }
  };

  return (
    <SemanticUI.Dropdown
      placeholder={placeholder}
      fluid
      search
      selection
      onChange={handleChange}
      value={widgetType}
      options={widgetTypeOptions}
    />
  );
};

export default WidgetTypeDropdown;
WidgetTypeDropdown.defaultProps = defaultProps;
